import React from 'react';
import PropTypes from 'prop-types';
import { formatCurrency } from 'utils/currencyFormatter';
import { getPriceDisplayData } from 'utils/priceDiscount';

/**
 * Componente para mostrar precio con descuento de producto
 * Muestra: precio original tachado, precio con descuento (naranja), porcentaje (verde)
 */
const PriceWithDiscount = ({ price, discount, className, showPercent = true }) => {
  const { originalPrice, discountedPrice, discountPercent, hasDiscount } = getPriceDisplayData(
    price,
    discount
  );

  if (hasDiscount) {
    return (
      <div className={`price-with-discount ${className || ''}`}>
        <span className="price-with-discount__original">{formatCurrency(originalPrice)}</span>
        <span className="price-with-discount__discounted">{formatCurrency(discountedPrice)}</span>
        {showPercent && <span className="price-with-discount__percent">(-{discountPercent}%)</span>}
      </div>
    );
  }

  return <span className={className}>{formatCurrency(originalPrice)}</span>;
};

PriceWithDiscount.propTypes = {
  price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  discount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  showPercent: PropTypes.bool,
};

PriceWithDiscount.defaultProps = {
  price: 0,
  discount: 0,
  className: '',
  showPercent: true,
};

export default PriceWithDiscount;
